import { Colors } from "@/components/common";

const relatedServices = {
  TransportacionBECAEducativo: 1,
  TransportacionBECATER: 2
};

const relatedServiceStatus = {
  Pending: 1,
  Compliment: 2,
  Excluded: 3,
  PendingApproval: 4,
  ReturnedToPending: 7
};

const relatedServiceCategoryTypes = {
  Scholarship: 1,
  Therapy: 2,
  Evaluation: 3
};

const relatedServiceViewTypes = {
  AdditionalInfo: 1,
  ManageInfoAccomplish: 2,
  ManageInfoExclude: 3,
  Management: 4,
  Deny: 5,
  History: 6
};

const stipulationTypes = {
  St40: 19,
  St85: 20,
  St86: 21
};

const complianceStates = {
  Pending: 1,
  Compliment: 2,
  Excluded: 3,
  PendingApproval: 4,
  ReturnedToPending: 7
};

const getRelatedServiceStatusColor = statusId => {
  switch (statusId) {
    case relatedServiceStatus.Pending:
    case relatedServiceStatus.PendingApproval:
    case relatedServiceStatus.ReturnedToPending:
      return Colors.YELLOW;
    case relatedServiceStatus.Compliment:
      return Colors.GREEN_LIGHT;
    case relatedServiceStatus.Excluded:
      return Colors.VIOLET;
    default:
      return null;
  }
};

export {
  relatedServices,
  relatedServiceStatus,
  relatedServiceViewTypes,
  relatedServiceCategoryTypes,
  getRelatedServiceStatusColor,
  stipulationTypes,
  complianceStates
};
